import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-390e4faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "surface-50 relative" }
const _hoisted_2 = { class: "p-2 surface-border border-bottom-2" }
const _hoisted_3 = { class: "flex flex-column md:flex-row md:justify-content-between" }
const _hoisted_4 = { class: "pb-2 pt-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-2 ml-5"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "w-4 grid"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "partner",
  class: "col-12 p-0 pl-2 mt-1 md:col-2 md:mb-0 md:p-2"
}, "Partner", -1))
const _hoisted_9 = { class: "col-12 p-0 pl-2 md:col-7 md:p-2" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "p-2 surface-border border-bottom-2 flex flex-row flex-wrap align-items-center" }
const _hoisted_14 = { class: "pb-2 pt-2 font-medium text-xl uppercase" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row flex-wrap"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  class: "flex flex-row flex-wrap"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "flex p-2 w-12 flex-wrap h-full" }
const _hoisted_24 = { class: "w-full lg:w-6 p-2 surface-card shadow-2 border-round-lg h-full align-items-center justify-content-center" }
const _hoisted_25 = {
  key: 0,
  class: "w-full lg:w-6 m-0 p-2 surface-card shadow-2 border-round-lg h-full align-items-center justify-content-center"
}
const _hoisted_26 = { class: "w-full flex flex-row flex-wrap mb-2" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Parapet", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/parapet-001.png",
  width: "150",
  alt: "Parapet"
}, null, -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Strieška", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/strieska.png",
  width: "150",
  alt: "Strieška"
}, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "w-full flex flex-row flex-wrap" }
const _hoisted_36 = { class: "w-7 h-2rem flex flex-row flex-wrap" }
const _hoisted_37 = { class: "w-37 align-items-center justify-content-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "parapet",
  class: "text-700 pt-1 mr-2"
}, "Parapet", -1))
const _hoisted_39 = { class: "w-5 h-2rem ml-0 flex flex-row flex-wrap" }
const _hoisted_40 = { class: "w-full mt-2" }
const _hoisted_41 = {
  key: 0,
  class: "flex flex-row flex-wrap shadow-2 bg-red-300 border-round-lg m-2 alert alert-danger"
}
const _hoisted_42 = {
  key: 1,
  class: "flex flex-row flex-wrap surface-50"
}
const _hoisted_43 = { class: "align-items-center justify-content-center w-3 surface-card shadow-2 border-round-lg m-2" }
const _hoisted_44 = {
  key: 0,
  class: "align-items-center justify-content-center w-3 surface-card shadow-2 border-round-lg m-2"
}
const _hoisted_45 = {
  key: 1,
  class: "align-items-center justify-content-center w-3 surface-card shadow-2 border-round-lg m-2"
}
const _hoisted_46 = {
  key: 2,
  class: "flex flex-row flex-wrap"
}
const _hoisted_47 = { class: "align-items-center justify-content-center w-12 surface-card shadow-2 border-round-lg m-2" }
const _hoisted_48 = { class: "w-9 ml-2 mt-2 surface-card shadow-2 border-round-lg h-full flex flex-row flex-wrap align-items-center justify-content-center" }
const _hoisted_49 = { class: "w-4 p-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "additions" }, "Doplňujúci materiál", -1))
const _hoisted_51 = { class: "w-4 p-2" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "comments" }, "Poznámky", -1))
const _hoisted_53 = { class: "w-4 p-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "comments" }, "Poznámka ku sklám", -1))
const _hoisted_55 = {
  key: 3,
  class: "w-9 ml-2 mt-2 surface-card shadow-2 border-round-lg h-full align-items-center justify-content-center"
}
const _hoisted_56 = { key: 4 }
const _hoisted_57 = { class: "flex flex-row flex-wrap" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_60 = { class: "mr-1 font-medium" }
const _hoisted_61 = { class: "mr-1 font-medium" }
const _hoisted_62 = { class: "font-medium" }
const _hoisted_63 = { class: "bottom-action-row" }
const _hoisted_64 = {
  key: 0,
  class: "ml-1 ext-muted fs-6 text-lg text-yellow-500"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "email bol už zaslaný", -1))
const _hoisted_66 = [
  _hoisted_65
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_glazing_wall = _resolveComponent("glazing-wall")!
  const _component_bks_wall = _resolveComponent("bks-wall")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_UploadFiles = _resolveComponent("UploadFiles")!
  const _component_AttachmentList = _resolveComponent("AttachmentList")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EmailList = _resolveComponent("EmailList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode("Odberateľ: " + _toDisplayString(this.store.order.user.company) + " (", 1),
            _createElementVNode("em", null, _toDisplayString(this.store.order.user.firstName) + " " + _toDisplayString(this.store.order.user.lastName) + ", " + _toDisplayString(this.store.order.user.phone), 1),
            _createTextVNode(") ")
          ]),
          _createElementVNode("div", null, [
            _createTextVNode("Aktuálny stav: "),
            _createVNode(_component_Tag, {
              class: "p-2 ml-1 font-medium text-base",
              value: this.store.order.currentState.label,
              severity: $options.Utils.getStateSeverity(this.store.order.currentState.reference)
            }, null, 8, ["value", "severity"])
          ]),
          (this.store.order.id > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("em", null, [
                  _createTextVNode("Objednávka naposledy uložená "),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString($options.Utils.parseToSlovakDateTime(this.store.order.modifiedDate)) + " - " + _toDisplayString(this.store.order.modifiedUser.firstName) + " " + _toDisplayString(this.store.order.modifiedUser.lastName), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        ($data.store.user.role.id === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_PrimevueSelect, {
                  id: "partner",
                  modelValue: $data.selectedPartner,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedPartner) = $event)),
                  options: $data.store.partners,
                  optionLabel: "firstName",
                  placeholder: "Vyber partnera",
                  class: "w-full"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.company ? slotProps.value.company + ' - ' : '') + " " + _toDisplayString(slotProps.value.firstName) + " " + _toDisplayString(slotProps.value.lastName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.company ? slotProps.option.company + ' - ' : '') + " " + _toDisplayString(slotProps.option.firstName) + " " + _toDisplayString(slotProps.option.lastName), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, " #" + _toDisplayString(this.store.order.orderNumber) + " - " + _toDisplayString(this.store.type.name) + " - " + _toDisplayString(this.typeBarrierName), 1),
        ($data.store.user.role.id !== 3 && this.isBarrier && this.store.order.type.code != $options.TypeCode.B_F_H)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (this.pdfMaterialScreenLink !== '' )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: this.pdfMaterialScreenLink,
                    class: "mr-5 ml-5",
                    target: "_blank"
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "PDF materiál",
                      text: "",
                      raised: "",
                      class: "uppercase",
                      icon: "pi pi-eye"
                    })
                  ], 8, _hoisted_16))
                : _createCommentVNode("", true),
              (this.pdfGlassScreenLink !== '')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: this.pdfGlassScreenLink,
                    class: "mr-5",
                    target: "_blank"
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "PDF sklá",
                      text: "",
                      raised: "",
                      class: "uppercase",
                      icon: "pi pi-eye"
                    })
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        ($data.store.user.role.id === 1 &&  this.store.order.type.code == $options.TypeCode.B_F_H)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (this.pdfProductionLink !== '' )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: this.pdfProductionLink,
                    class: "mr-5 ml-5",
                    target: "_blank"
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "Zobraziť PDF výrobný list",
                      text: "",
                      raised: "",
                      class: "uppercase",
                      icon: "pi pi-eye"
                    })
                  ], 8, _hoisted_19))
                : _createCommentVNode("", true),
              (this.pdfProductionPrintLink !== '' )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: this.pdfProductionPrintLink,
                    class: "mr-5 ml-5",
                    target: "_blank"
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "Tlačiť PDF výrobný list",
                      text: "",
                      raised: "",
                      class: "uppercase",
                      icon: "pi pi-print"
                    })
                  ], 8, _hoisted_20))
                : _createCommentVNode("", true),
              (this.pdfBksProfilePrintLink !== '' )
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: this.pdfBksProfilePrintLink,
                    class: "mr-5 ml-5 mb-5",
                    target: "_blank"
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "Tlačiť BKS profil",
                      text: "",
                      raised: "",
                      class: "uppercase",
                      icon: "pi pi-print",
                      severity: "success"
                    })
                  ], 8, _hoisted_21))
                : _createCommentVNode("", true),
              (this.dxfGlassLink !== '')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: this.dxfGlassLink,
                    class: "mr-5",
                    target: "_blank"
                  }, [
                    _createVNode(_component_PrimevueButton, {
                      label: "DXF Sklá",
                      text: "",
                      raised: "",
                      class: "uppercase",
                      icon: "pi pi-download"
                    })
                  ], 8, _hoisted_22))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_InputGroup, { class: "h-2rem" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "wfloorlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Meno a priezvisko ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "justify-content-start wfloorinp",
                inputStyle: { background: '#b8d6f0', textAlign: 'left' },
                name: "nameSurname",
                id: "nameSurname",
                placeholder: "Zadaj meno a priezvisko",
                "required:string": "required",
                modelValue: this.store.order.customerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.store.order.customerName) = $event)),
                autocomplete: "nameSurname-new"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputGroupAddon, { class: "wterminlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Mobilný kontakt ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "wtermincal justify-content-start",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "phone",
                id: "phone",
                placeholder: "Zadaj telefón",
                "required:string": "required",
                modelValue: this.store.order.phone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.store.order.phone) = $event)),
                autocomplete: "phone-new"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "wfloorlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Adresa ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "justify-content-start wfloorinp",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "address",
                id: "address",
                placeholder: "Zadaj adresu",
                "required:string": "required",
                modelValue: this.store.order.address,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.store.order.address) = $event)),
                autocomplete: "address-new"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputGroupAddon, { class: "wterminlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("E-mail ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                type: "email",
                class: "wtermincal justify-content-start",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "email",
                id: "email",
                placeholder: "Zadaj e-mail",
                "required:string": "required",
                modelValue: this.store.order.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.store.order.email) = $event)),
                autocomplete: "email-new"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "wfloorlab-2 h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Poschodie ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputNumber, {
                inputId: "poschodie",
                class: "justify-content-start wfloorinp-2",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "floor",
                id: "floor",
                placeholder: "Zadaj poschodie",
                "required:string": "required",
                modelValue: this.store.order.floor,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.store.order.floor) = $event)),
                autocomplete: "floor-new"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputGroupAddon, { class: "wterminlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Termín montáže ")
                ]),
                _: 1
              }),
              _createVNode(_component_Calendar, {
                class: "wtermincal-2",
                modelValue: $data.termin,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.termin) = $event)),
                showIcon: "",
                dateFormat: "dd.mm.yy"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        (this.isBarrier)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                (this.store.order.parapet == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
                  : _createCommentVNode("", true),
                (this.store.order.roof !== 'NONE')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_Checkbox, {
                      class: "",
                      modelValue: this.store.order.parapet,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.store.order.parapet) = $event)),
                      binary: true,
                      inputId: "parapet"
                    }, null, 8, ["modelValue"])
                  ]),
                  (this.store.order.parapet == true)
                    ? (_openBlock(), _createBlock(_component_InputGroup, {
                        key: 0,
                        class: "w-7 h-2rem"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputGroupAddon, { class: "w-1 font-normal text-base text-700 justify-content-start" }, {
                            default: _withCtx(() => [
                              _createTextVNode("A")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            class: "justify-content-start w-1",
                            inputStyle: "background: #b8d6f0; text-align: left; padding-left: 0.2rem; padding-right: 0.1rem",
                            name: "parapetA",
                            id: "parapetA",
                            placeholder: "",
                            "required:string": "required",
                            modelValue: this.store.order.parapetDimA,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.store.order.parapetDimA) = $event)),
                            autocomplete: "parapetA-new"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_InputGroupAddon, { class: "w-1 font-normal text-base text-700 justify-content-start" }, {
                            default: _withCtx(() => [
                              _createTextVNode("B")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            class: "justify-content-start w-1",
                            inputStyle: "background: #b8d6f0; text-align: left; padding-left: 0.2rem; padding-right: 0.1rem",
                            name: "parapetB",
                            id: "parapetB",
                            placeholder: "",
                            "required:string": "required",
                            modelValue: this.store.order.parapetDimB,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.store.order.parapetDimB) = $event)),
                            autocomplete: "parapetB-new"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_InputGroup, { class: "flex w-full h-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputGroupAddon, { class: "w-4 p-myroof h-1.9rem font-normal text-base text-700 justify-content-start" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Strieška ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Dropdown, {
                        modelValue: this.store.order.roof,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((this.store.order.roof) = $event)),
                        options: this.store.roof_type,
                        optionLabel: "name",
                        optionValue: "code",
                        placeholder: this.store.order.roof,
                        class: "w-2 h-2.1rem",
                        inputStyle: "padding-left: 0.2rem; padding-top: 0.3rem"
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ]),
                    _: 1
                  }),
                  (this.store.order.roof !== 'NONE')
                    ? (_openBlock(), _createBlock(_component_InputGroup, {
                        key: 0,
                        class: "flex w-5 h-2rem ml-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputGroupAddon, { class: "w-1 font-normal text-base text-700 justify-content-start" }, {
                            default: _withCtx(() => [
                              _createTextVNode("A")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            class: "justify-content-start w-1",
                            inputStyle: "background: #b8d6f0; text-align: left; padding-left: 0.2rem; padding-right: 0.1rem",
                            name: "roofA",
                            id: "roofA",
                            placeholder: "",
                            "required:string": "required",
                            modelValue: this.store.order.roofDimA,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.store.order.roofDimA) = $event)),
                            autocomplete: "roofA-new"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_InputGroupAddon, { class: "w-1 font-normal text-base text-700 justify-content-start" }, {
                            default: _withCtx(() => [
                              _createTextVNode("B")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            class: "justify-content-start w-1",
                            inputStyle: "background: #b8d6f0; text-align: left; padding-left: 0.2rem; padding-right: 0.1rem",
                            name: "roofB",
                            id: "roofB",
                            placeholder: "",
                            "required:string": "required",
                            modelValue: this.store.order.roofDimB,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.store.order.roofDimB) = $event)),
                            autocomplete: "roofB-new"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_InputGroup, { class: "w-full h-2rem" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputGroupAddon, { class: "w-4 h-full font-normal text-base text-700 justify-content-start" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Zábradlie ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Dropdown, {
                      modelValue: this.store.order.railingReplace,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.store.order.railingReplace) = $event)),
                      options: this.store.railing_type,
                      optionLabel: "name",
                      optionValue: "code",
                      placeholder: this.store.order.railingReplace,
                      class: "w-3 h-2.1rem",
                      inputStyle: "padding-left: 0.2rem; padding-top: 0.3rem"
                    }, null, 8, ["modelValue", "options", "placeholder"]),
                    _createVNode(_component_InputGroupAddon, { class: "w-4 h-full font-normal text-base text-700 justify-content-start" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Výplň ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Dropdown, {
                      modelValue: this.store.order.railingInfill,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.store.order.railingInfill) = $event)),
                      options: this.store.railing_in_fill_type,
                      optionLabel: "name",
                      optionValue: "code",
                      placeholder: this.store.order.railingInfill,
                      class: "w-3 h-2.1rem",
                      inputStyle: "padding-left: 0.2rem; padding-top: 0.3rem"
                    }, null, 8, ["modelValue", "options", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputGroup, { class: "w-full h-2rem" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputGroupAddon, { class: "w-1 h-full font-normal text-base text-700 justify-content-start" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pozn. ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_InputText, {
                      type: "email",
                      class: "w-full justify-content-start",
                      inputStyle: "background: #b8d6f0; text-align: left",
                      name: "railingComment",
                      id: "railingComment",
                      placeholder: "Zadaj poznámku k zábradliu",
                      modelValue: this.store.order.railingComment,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((this.store.order.railingComment) = $event)),
                      autocomplete: "railingComment-new"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (this.validationError != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(this.validationError), 1))
        : _createCommentVNode("", true),
      (this.isBarrier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_glazing_wall, {
                typeWall: $data.position.FRONT,
                isBarrier: this.isBarrier,
                typeCode: this.store.type.code,
                validationOK: this.validationOK,
                validationAttr: this.validationAttr
              }, null, 8, ["typeWall", "isBarrier", "typeCode", "validationOK", "validationAttr"])
            ]),
            (this.isLeft)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createVNode(_component_glazing_wall, {
                    typeWall: $data.position.LEFT,
                    isBarrier: this.isBarrier,
                    validationOK: this.validationOK,
                    validationAttr: this.validationAttr
                  }, null, 8, ["typeWall", "isBarrier", "validationOK", "validationAttr"])
                ]))
              : _createCommentVNode("", true),
            (this.isRight)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_component_glazing_wall, {
                    typeWall: $data.position.RIGHT,
                    isBarrier: this.isBarrier,
                    validationOK: this.validationOK,
                    validationAttr: this.validationAttr
                  }, null, 8, ["typeWall", "isBarrier", "validationOK", "validationAttr"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!this.isBarrier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_bks_wall, {
                typeWall: $data.position.FRONT,
                isBarrier: this.isBarrier,
                validationOK: this.validationOK,
                validationAttr: this.validationAttr
              }, null, 8, ["typeWall", "isBarrier", "validationOK", "validationAttr"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createVNode(_component_TextArea, {
            id: "additions",
            autoResize: "",
            rows: "2",
            class: "w-full",
            placeholder: "Zadaj doplňujúci materiál",
            modelValue: this.store.order.additions,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((this.store.order.additions) = $event)),
            autocomplete: "additions-new"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createVNode(_component_TextArea, {
            id: "comments",
            autoResize: "",
            rows: "2",
            class: "w-full",
            placeholder: "Zadaj poznámky",
            modelValue: this.store.order.comment,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((this.store.order.comment) = $event)),
            autocomplete: "comments-new"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createVNode(_component_TextArea, {
            id: "comments",
            autoResize: "",
            rows: "2",
            class: "w-full",
            placeholder: "Zadaj poznámku k výrobe skla",
            modelValue: this.store.order.glassesComment,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((this.store.order.glassesComment) = $event)),
            autocomplete: "comments-new"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (this.store.order.id > 0 && $data.store.order.user.role.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createVNode(_component_UploadFiles, {
              orderId: String(this.store.order.id)
            }, null, 8, ["orderId"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.order.user.role.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createVNode(_component_AttachmentList, {
              orderId: String(this.store.order.id)
            }, null, 8, ["orderId"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(_component_Card, { class: "shadow-2 m-2 w-3" }, {
          title: _withCtx(() => [
            _createTextVNode("Prehľad stavov")
          ]),
          content: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.orderHistory, (history) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: history.id
                }, [
                  _hoisted_58,
                  _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createDate)) + " ", 1),
                  _createVNode(_component_Tag, {
                    value: history.state.label,
                    severity: $options.Utils.getStateSeverity(history.state.reference)
                  }, null, 8, ["value", "severity"]),
                  _createTextVNode(" - " + _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (this.store.emailHistories.length > 0)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "shadow-2 m-2 w-6"
            }, {
              title: _withCtx(() => [
                _createTextVNode("Prehľad histórie zaslaných emailov")
              ]),
              content: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.emailHistories, (history) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: history.id
                    }, [
                      _hoisted_59,
                      _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createDate)) + " Od: ", 1),
                      _createElementVNode("span", _hoisted_60, _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1),
                      _createTextVNode(" Komu: "),
                      _createElementVNode("span", _hoisted_61, _toDisplayString(history.whom), 1),
                      _createTextVNode(" Predmet: "),
                      _createElementVNode("span", _hoisted_62, _toDisplayString(history.subject), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("a", {
        class: "mr-5",
        onClick: _cache[19] || (_cache[19] = ($event: any) => ($options.saveOrder()))
      }, [
        _createVNode(_component_PrimevueButton, {
          label: "ULOŽIŤ a PREPOČÍTAŤ",
          raised: "",
          class: "uppercase",
          severity: "info",
          icon: "pi pi-save",
          disabled: $data.store.user.role.id === 2 ? this.store.hasBeenSent : false 
        }, null, 8, ["disabled"])
      ]),
      (this.store.order.id > 0 && ($data.store.user.role.id === 1 || $data.store.user.role.id === 2))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "mr-2 ml-2",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (!this.store.hasBeenSent ? $options.Utils.changeState($options.Models.State.SENT) : null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Odoslať",
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.SENT),
              disabled: this.store.hasBeenSent
            }, null, 8, ["severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.user.role.id !== 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "mr-2 ml-2",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (!this.store.hasBeenInProduction ? $options.Utils.changeState($options.Models.State.PRODUCTION): null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: $data.store.user.role.id === 3 ? 'Odoslať do výroby' : 'Nastaviť výrobu',
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.PRODUCTION),
              disabled: this.store.hasBeenInProduction || ($data.store.user.role.id === 1 ? !this.store.hasBeenSent : false)
            }, null, 8, ["label", "severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.user.role.id !== 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "mr-2 ml-2",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (!this.store.hasBeenReady && this.store.hasBeenInProduction ? $options.Utils.changeState($options.Models.State.READY): null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Pripravená na prevzatie",
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.READY),
              disabled: this.store.hasBeenReady ||  !this.store.hasBeenInProduction || !this.store.hasBeenSent
            }, null, 8, ["severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.user.role.id !== 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            class: "mr-2 ml-2",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (!this.store.hasBeenFinished && this.store.hasBeenReady ? $options.Utils.changeState($options.Models.State.FINISH): null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Ukončená",
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.FINISH),
              disabled: !this.store.hasBeenReady || this.store.hasBeenFinished
            }, null, 8, ["severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      ($data.store.user.role.id !== 2 && this.store.emailLink !== '')
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            onClick: _cache[24] || (_cache[24] = ($event: any) => (this.store.isSendEmail = !this.store.isSendEmail))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Email",
              severity: this.store.hasBeenEmailSent ? 'warning' : 'success',
              raised: "",
              class: "uppercase ml-5",
              icon: "pi pi-envelope"
            }, null, 8, ["severity"]),
            (this.store.hasBeenEmailSent)
              ? (_openBlock(), _createElementBlock("em", _hoisted_64, _hoisted_66))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (this.store.isSendEmail && this.store.emailLink !== '')
        ? (_openBlock(), _createBlock(_component_EmailList, {
            key: 5,
            modelValue: this.recipId,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((this.recipId) = $event)),
            options: this.store.emailRecipientOptions,
            optionLabel: "name",
            optionValue: "id",
            class: "md:w-30rem absolute email-list",
            onChange: _cache[26] || (_cache[26] = ($event: any) => ($options.sendEmail()))
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}